<template>
  <section id="luckdraw">
    <div class="panBox">
      <img class="pan" :style="{ transform: `rotate(${deg}deg) translateZ(0)`, 'transition-duration': `${dur}s`}" src="../assets/luckdraw/pan.png" alt="">
      <img class="pointer" src="../assets/luckdraw/pointer.png" alt="">
      <img class="start" ref="start" src="../assets/luckdraw/start.png" alt="">
    </div>
    <transition name="fade">
      <div class="resBox" v-show="show">
        <img v-for="(n, i) in gift" :key="i" v-show="i == res" :src="require(`../assets/luckdraw/res${n.id}.png`)" alt="">
      </div>
    </transition>
  </section>
</template>

<script>
import { fromEvent, of } from 'rxjs';
import { delay, mergeMap, switchMap, tap, throttleTime, take } from 'rxjs/operators';
export default {
  name: "Luckdraw",
  data() {
    return {
      num: -1,
      deg: 0,
      dur: Math.floor(Math.random()*5) + 5,
      gift: [
        { id: 1, deg: 0, keypoint: 0},
        { id: 2, deg: 45, keypoint: 0},
        { id: 3, deg: 90, keypoint: 120},
        { id: 4, deg: 135, keypoint: 140},
        { id: 5, deg: 180, keypoint: 160},
        { id: 6, deg: 225, keypoint: 180},
        { id: 7, deg: 270, keypoint: 200},
        { id: 8, deg: 325, keypoint: 1000},
      ],
      res: -1,
      show: false
    };
  },
  components: {},
  computed: {},
  methods: {
    
  },
  mounted() {
    // setTimeout(() => {
    //   this.deg = 360*10 + 120
    // }, 1e3);
    
    this.$nextTick(()=>{
      fromEvent(this.$refs.start, 'click').pipe(
        take(1),
        tap(()=>{
          this.num = Math.ceil(Math.random()*1e3);
          this.res = this.gift.findIndex(item=> item.keypoint> this.num);
          this.deg = 360*(10+Math.floor(Math.random()*8)) - 45*this.res;
          console.log(`res`, this.res, `num`, this.num);
        }),
        delay((this.dur+1) * 1e3),
        tap(()=>console.log(this.dur)),
        tap(()=>{
          //
          this.show = true
        }),
      ).subscribe();
    })
  }
};
</script>

<style lang="scss" scoped>
#luckdraw {
  position: relative;
  margin: 0 auto;
  width: 750px;
  height: 1508px;
  background: url(../assets/luckdraw/bg.png) bottom/750px no-repeat #fff;
  overflow: hidden;

  .panBox {
    position: absolute;
    left: 50%;
    top: 390px;
    margin-left: -319px;
    width: 638px;
    height: 638px;

    .pan {
      position: absolute;
      left: 0;
      top: 0;
      width: 638px;
      // transition: all 5s cubic-bezier(.57,1.11,.57,1.04);
      transition: all 5s ease-in-out;
    }
    .pointer {
      position: absolute;
      left: 216px;
      top: -32px;
    }
    .start {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -67px 0 0 -67px;
      cursor: pointer;
      pointer-events: auto;
    }
  }
  .resBox {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.8);
    > img {
      display: block;
      margin-top: -200px;
      width: 530px;
    }
  }
  @media (max-width: 750px) {
    
  }
}
</style>
